// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import EmailVerificationPrompt from './EmailVerificationPrompt';
import OrgIdRequiredPrompt from './OrgIdRequiredPrompt'; // Import the new component

function ProtectedRoute({ element, requireAdmin = false }) {
  const { currentUser, loadingAuth, userOrgId, isAdmin } = useAuth();

  // 1. Show a loading indicator while auth state is being determined
  if (loadingAuth) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2 text-muted">Loading User...</p>
      </div>
    );
  }

  // 2. If not logged in, redirect to the login page
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // 3. If email is not verified, show the verification prompt
  if (!currentUser.emailVerified) {
    return <EmailVerificationPrompt />;
  }

  // 4. NEW: If email is verified BUT user is not in a directory, show the org prompt
  if (!userOrgId) {
    return <OrgIdRequiredPrompt />;
  }

  // 5. If admin is required but user is not admin, redirect to dashboard
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // 6. If all checks pass, render the requested component
  return element;
}

export default ProtectedRoute;